import React from "react";
import "./komets-banner.scss";


function KometsBanner(props) {
return (



<div className='komets-banner'>
<div className='k-container'>
  <img src="./assets/komet-logo.png" alt="Fort Wayne Komets Hockey Logo" />
  <h2>We are a proud Komet Hockey Sponsor!</h2>
</div>
</div>

)
};

export default KometsBanner;